import React from 'react';
import './Services.css';

const servicesData = [
  {
    id: 1,
    title: "Orthopedic Physiotherapy",
    description: "Specialized treatment for bone, joint, and muscle conditions",
    icon: "🦴",
    image: "/assets/images/orthopedic.png"
  },
  {
    id: 2,
    title: "Sports Injury Physiotherapy",
    description: "Recovery and rehabilitation for sports-related injuries",
    icon: "⚽",
    image: "/assets/images/Sports-Injury-Physiotherapy.png"
  },
  {
    id: 3,
    title: "Post-Operative Physiotherapy",
    description: "Comprehensive care for post-surgical recovery",
    icon: "🏥",
    image: "/assets/images/post-operative.png"
  },
  {
    id: 4,
    title: "Neurological Physiotherapy",
    description: "Treatment for neurological conditions and disorders",
    icon: "🧠",
    image: "/assets/images/neurological.png"
  },
  {
    id: 5,
    title: "Physiotherapy For Elderly",
    description: "Specialized care for age-related mobility issues",
    icon: "👴",
    image: "/assets/images/elderly-care.png"
  }
];

const Services = () => {
  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>We Provide Physiotherapy For:</h2>
          <p>Comprehensive physiotherapy services tailored to your specific needs</p>
        </div>

        <div className="services-grid">
          {servicesData.map(service => (
            <div key={service.id} className="service-card">
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-icon">{service.icon}</div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                {/* <button className="btn-primary">Book Now</button> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;